<template>
  <q-dialog v-model="visible" full-height position="right">
    <q-card style="width: 500px">
      <q-toolbar class="auto-height horizontal-line">
        <q-toolbar-title class="q-pa-sm"> {{ $t('label.form_select') }} </q-toolbar-title>
        <q-btn flat round dense icon="close" v-close-popup />
      </q-toolbar>
      <q-card-section>
        <div class="text-subtitle2 text-bold q-mb-sm">新規フォーム作成</div>
        <q-btn no-caps color="brand" @click="onAdd()" :label="$t('label.form.compose_new_form')" class="full-width" />
        <div class="text-subtitle2 text-bold q-mt-sm">フォーム一覧</div>
        <q-list separator dense>
          <q-item v-for="form in forms" :key="form._id" clickable>
            <q-item-section avatar>
              <q-icon size="20px" color="black" name="question_answer" v-if="form.type === 'chat'" />
              <q-icon size="20px" color="black" name="dynamic_form" v-else />
            </q-item-section>
            <q-item-section class="text-bold">
              <q-item-label class="full-width ellipsis">
                {{ form.title || '-' }}
              </q-item-label>
            </q-item-section>
            <q-item-section side>
              <q-btn
                no-caps
                outline
                dense
                color="brand"
                class="btn-fixed-width"
                @click="onSelect(form)"
                :label="$t('select')"
              />
            </q-item-section>
          </q-item>
        </q-list>
      </q-card-section>
    </q-card>
  </q-dialog>
  <FormFormModal
    v-if="modalFormVisible"
    :modalVisible="modalFormVisible"
    :formConfig="selectedForm"
    @update:closeModal="onCloseModal"
    @update:onSelect="onSelect"
    @update:onCreate="onCreate"
  />
</template>

<script lang="ts">
import { Vue, Options } from 'vue-class-component'
import { Emit, Prop } from 'vue-property-decorator'
import { maska } from 'maska'
import { IForm } from '@/utils/types'
import FormFormModal from '@/components/form/FormFormModal.vue'

@Options({
  components: { FormFormModal },
  directives: { maska },
  emits: ['update:closeModal', 'update:onSelect', 'update:onCreate'],
})
export default class FormSelectorModal extends Vue {
  @Prop()
  modalVisible!: boolean

  modalFormVisible = false
  selectedForm: IForm = {}

  get visible() {
    return this.modalVisible
  }

  set visible(value) {
    this.$emit('update:closeModal', value)
  }

  get forms(): IForm[] {
    const forms = this.$store.getters.forms
    return [...forms].reverse()
  }

  get appId() {
    return this.$route?.params?.app_id as string
  }

  @Emit('update:onSelect')
  onSelect(form: IForm) {
    return form
  }

  @Emit('update:onCreate')
  onCreate(form: IForm) {
    return form
  }

  onCancel() {
    this.visible = false
  }

  onAdd() {
    this.selectedForm = {
      app_id: this.appId,
    }

    this.modalFormVisible = true
  }

  onCloseModal() {
    this.modalFormVisible = false
    this.selectedForm = {}
  }
}
</script>

<style lang='scss' scoped>
.btn-fixed-width {
  width: 40px;
  height: 24px;
}
:deep(.btn-fixed-width span.q-btn__content) {
  font-size: 12px;
  line-height: 1rem;
}
:deep(.btn-fixed-width span.q-btn__content span.block) {
  line-height: 1rem;
}
:deep(.q-item__section--side) {
  padding-right: 0;
}
:deep(.q-item__section--side.q-item__section--avatar) {
  padding-right: 8px;
}
:deep(.q-item__section--avatar) {
  min-width: 20px;
}
</style>
